import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppCoreService } from 'src/app/services/app-core.service';
import Swal from 'sweetalert2';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { EditDeleteActionsRenderer } from 'src/app/components/shared/ag-grid/cell-renderers/edit-delete.component';
import { ColumnApi, GridApi, GridReadyEvent, ColDef, GridOptions } from 'ag-grid-community';
import { DRSService } from 'src/app/services/operations/drs.service';
import printJS from 'print-js-updated';
import { Utilities } from 'src/app/models/utilities';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { UploadDRSCopyComponent } from '../upload-copy/upload-copy.component';
import { Title } from '@angular/platform-browser';
import { ExcelService } from 'src/app/services/excel.service';
import { lastValueFrom } from 'rxjs';
@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListDRSComponent implements OnInit {
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  isActionAllowed = true;
  public isCollapsed = true;
  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public context: any;
  defaultColDef = {
    sortable: true,
    resizable: false,

  };
  gridOptions: GridOptions = {
    pagination: true,
    paginationPageSize: 20,
    domLayout: "autoHeight"
  }
  columnDefs: ColDef[] = [
    // { headerName: 'Serial Id', field: 'id', filter: true },
    { headerName: 'DRS No.', field: 'drsfullno', filter: true, minWidth: 70, },
    {
      headerName: 'Date and Time',
      field: 'drsdate',
      minWidth: 70,
      filter: 'agDateColumnFilter',
      sortable: true,
      cellRenderer: (params: { value: string; }) => this.utilities.getFormattedDate(new Date(params.value)).dateTimeString,
      comparator: (valueA: string, valueB: string) => {
        if (!valueA || !valueB) return 0; // Handle empty values

        const [dayA, monthA, yearA] = valueA.split('-').map(Number);
        const [dayB, monthB, yearB] = valueB.split('-').map(Number);

        return new Date(yearA, monthA - 1, dayA).getTime() - new Date(yearB, monthB - 1, dayB).getTime();
      },
      filterParams: {
        comparator: (filterDate: Date, cellValue: string) => {
          if (!cellValue) return 0;
      
          const cellDate = this.parseCustomDate(cellValue).setHours(0, 0, 0, 0); // Normalize date
          const filterTime = filterDate.setHours(0, 0, 0, 0); // Normalize date
      
          return cellDate - filterTime;
        },
        browserDatePicker: true,
        defaultOption: 'inRange',
        suppressAndOrCondition: true,
        suppressFilterButton: false,
        buttons: ['reset'],
        inRangeInclusive: true, // Includes 'to' date
      }
    },
    { headerName: 'AWB Count', field: 'awbcount' },
    { headerName: 'Field Executive', field: 'fieldexecutive' },
    {
      headerName: 'Status',
      field: 'status',
      minWidth: 80,
      pinned: 'right',
      cellRenderer: (params: { value: string; }) => {
        let statusHtml = `<span class="badge bg-light">${params.value}</span>`;

        if (params.value === 'DRS_CREATED') {
          statusHtml = `<span class="badge bg-light">CREATED</span>`;
        } else if (params.value === 'DRS_PARTIALLY_DELIVERED') {
          statusHtml = `<span class="badge bg-primary">PARTIALLY DELIVERED</span>`;
        } else if (params.value === 'DRS_DELIVERED') {
          statusHtml = `<span class="badge bg-success">DELIVERED</span>`;
        } else {
          statusHtml = `<span class="badge bg-dark">${params.value ? (params.value.split('_')[1] || params.value) : ''}</span>`;
        }
        return statusHtml;
      }
    },
    {
      headerName: 'Actions',
      field: 'id',
      cellRenderer: EditDeleteActionsRenderer,
      colId: 'params',
      editable: false,
      sortable: false,
      minWidth: 80,
      pinned: 'right',
    },
  ];
  rowData = [];
  selectedSCId: number;
  configDetail: any;
  parseCustomDate(dateStr: string): Date {
    if (!dateStr) return new Date(0); // Handle empty values
  
    // Check if the format is ISO (YYYY-MM-DDTHH:mm:ss)
    if (dateStr.includes('T')) {
      return new Date(dateStr); // Directly parse ISO format
    }
  
    // Otherwise, assume it's in "DD/MM/YYYY, HH:mm:ss AM/PM" format
    const [datePart, timePart] = dateStr.split(', ');
    if (!datePart || !timePart) return new Date(0);
  
    const [day, month, year] = datePart.split('/').map(Number);
    const [time, period] = timePart.split(' ');
    const [hours, minutes, seconds] = time.split(':').map(Number);
  
    let parsedHours = hours;
    if (period?.toLowerCase() === 'pm' && hours !== 12) parsedHours += 12;
    if (period?.toLowerCase() === 'am' && hours === 12) parsedHours = 0;
  
    return new Date(year, month - 1, day, parsedHours, minutes, seconds);
  }
  
  constructor(
    public router: Router,
    private appCoreService: AppCoreService,
    private ngxLoaderService: NgxUiLoaderService,
    private drsService: DRSService,
    private modalService: NgbModal,
    private utilities: Utilities,
    private titleService: Title,
    private excelService: ExcelService 
  ) {
    titleService.setTitle('DRS');
    this.context = { componentParent: this, componentName: 'DRSComponent', 
      actionConfig: { printAction: true} };
  }

  ngOnInit() {
    this.checkPermission();
    if (this.permConfig.isViewAllowed) {
      this.appCoreService.SelectedServiceCenter().subscribe((val) => {
        this.selectedSCId = val;
        // console.log('this.selectedSCId', this.selectedSCId);
        this.bindList();
      });
    }
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    const permission = userData.config.filter(x => x.categoryname === 'DRSScan');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  async printPDF(drsId: any, printType: string) {
    if (printType === 'uploadcopy') {
      //call upload copy
      this.uploadDrsCopy(drsId)
    } else if (printType === 'exportexcel'){
      this.ngxLoaderService.start();
      const res = await lastValueFrom(this.drsService.GetById(drsId));
      if(res){
      this.ngxLoaderService.stop();
      const drsAWBRows = res.data[0]?.drsawb;
      const drsfullno = res.data[0]?.drsfullno;
      const fieldexecutive = res.data[0]?.fieldexecutive;
      const datetime = res.data[0].datetime?.split('T')[0];
      const name = drsfullno?.replace(/\//g, "_");

      // Format Excel with correct column order
      const formattedDRSRows = drsAWBRows.map((row) => ({
        'DRS No.': drsfullno.trim(),
        'DRS date': datetime.trim(),
        'Field Executive': fieldexecutive?.trim() || '',
        'AWB Number': row.awbnumber.trim(),
        'Origin': row.origin.trim(),
        'Destination': row.destination.trim(),
        'Consignee Tel': row.consigneetel?.trim() || '',
        'Consignee Mobile': row.consigneemobile?.trim() || '',
        'Consignee Pincode': row.consigneepincode?.trim() || '',
        'Weight': parseFloat(row.actualweight).toFixed(3),
        'Amount To Pay': parseFloat(row.totalamount).toFixed(2)
      }));
        
        // console.log(formattedDRSRows); // Check if columns are correct
        this.excelService.exportAsExcelFile(formattedDRSRows, name, true);
      }
    } else {
      this.ngxLoaderService.start();
      try {
        this.drsService.GeneratePDF(drsId).subscribe((res) => {
          if (res && res.success) {
            this.ngxLoaderService.stop();
            let pdfString = JSON.parse(res.data);
            printJS({ printable: pdfString, type: 'pdf', base64: true, showModal: true });
          }
        });
      } catch (error) {
        this.ngxLoaderService.stop();
      }
    }

  }

  uploadDrsCopy(id: number) {
    //
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'md',
      backdrop: 'static',
      keyboard: false,
      centered: true
    };
    const modalRef = this.modalService.open(UploadDRSCopyComponent, ngbModalOptions);
    modalRef.componentInstance.selectedSCId = this.selectedSCId;
    modalRef.componentInstance.drsId = id;
    modalRef.result.then(
      (result) => {
        if (result) {
          if (result == 'Import Successfully') {
            this.bindList();
          }
        }
      },
    );
  }

  bindList(refresh = false) {
    try {
      this.ngxLoaderService.start();
      this.drsService.GetAllList({ id: this.selectedSCId, refresh: refresh }).subscribe((res: any) => {
        if (res && res.success) {
          this.ngxLoaderService.stop();
          // this.rowData = res.data.map(drs=> ({...drs, drsdate: this.utilities.FormatDateWithTime(0, drs.drsdate).dateTimeStringAMPM}));
          this.rowData = res.data;
        } else {
          this.ngxLoaderService.stop();
        }
      })
    } catch (e) {
      console.error(e);
      this.ngxLoaderService.stop();
    }
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  editAction(cell: any) {
    try {
      if (!this.permConfig.isEditAllowed) {
        this.errAlert('No Access to Edit.');
      }
      else if (this.permConfig.isEditAllowed && cell && cell.id) {
        this.router.navigate(['/operation/drs/edit', cell.id]);
      }

    } catch (e) {
      console.error(e);
    }

  }

  deleteAction(cell: any) {
    if (!this.permConfig.isDeleteAllowed) {
      this.errAlert('No Access to Delete.');
    }
    else if (this.permConfig.isDeleteAllowed && cell && cell.id) {
      this.openConfirmationDialog('Are you sure you want to delete ?', cell.id);
    }
  }

  deleteRecord(id) {
    try {
      if (id) {
        this.ngxLoaderService.start();
        this.drsService.Delete(id).subscribe((res) => {
          if (res && res?.success) {
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage('Record deleted successfully', 'Success', 'success');
            this.bindList(true);
          }
        });
      }
    } catch (e) {
      this.ngxLoaderService.stop();
      console.error(e);
    }
  }

  async openConfirmationDialog(msg: any, id?: number) {
    const result = await Swal.fire({
      titleText: 'Confirmation',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (result.isConfirmed) {
      this.deleteRecord(id);
    }

  }

  errAlert(msg: any) {
    Swal.fire({
      titleText: 'Opps!',
      html: msg,
      icon: 'warning',
      confirmButtonText: 'Ok',
    });
  }

}